import React, { useState, useEffect } from 'react';
import { Layout, Spin } from 'antd';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMsal } from '@azure/msal-react';
import useTemplateState from '../../../../Template/atoms/variables';

import CreateTestForm from './components/CreateTestForm';
import TestViewer from './components/TestViewer';

import { useTestData } from './hooks/useTestData';

const { Content } = Layout;

const TestBuilder = () => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const { t } = useTranslation();
  const { instance } = useMsal();
  const { setPendingApiCalls } = useTemplateState();

  // Para rota de edição (:id/edit), o id vem como params.id
  // Para rota de visualização (:id), também vem como params.id
  const testId = params.id;


  // Determinar o modo baseado na URL
  const isCreating = !testId || testId === 'create' || testId === 'new';
  const isEditing = location.pathname.endsWith('/edit');
  const isViewing = testId && !isCreating && !isEditing;

  // O ID real é sempre o parâmetro testId
  const actualTestId = testId;

  const { testData, loading, error } = useTestData(
    instance,
    setPendingApiCalls,
    isViewing || isEditing ? actualTestId : null,
  );

  const handleBack = () => navigate('/settings/tests');

  // Se está criando, mostra o formulário
  if (isCreating) {
    return <CreateTestForm />;
  }

  // Se está editando, mostra o formulário com dados
  if (isEditing) {
    return <CreateTestForm testId={actualTestId} existingData={testData} isLoading={loading} />;
  }

  // Se está visualizando, mostra o visualizador
  if (isViewing) {
    // Garantir que o testData tenha um ID consistente
    const testDataWithId = testData
      ? {
          ...testData,
          id: testData.id || testData._id || testData._id?.$oid || actualTestId,
        }
      : null;

    return <TestViewer testData={testDataWithId} isLoading={loading} />;
  }

  // Fallback - não deveria chegar aqui
  return <div>Invalid state</div>;
};

export default TestBuilder;
